import React from 'react'

import "../styles/card.css";

export const Card = (props) => {
  return (
    !props.hidden ? <div className='card-container'>
    <a className='card' href= {props.href}>
      <div className="pregled-card-text">
        {props.title}
      </div>

      <div className="go-corner" href="#">
        <div className="go-arrow">→</div>
      </div>
    </a>
  </div> : null
  )
}